import { Icon } from "@mui/material";
import { Table } from "../../../components/Table";
import { useQuery, useMutation } from "react-query";
import {
  listEmailTemplates,
  deleteTemplate,
} from "../../../services/templates";
import { format, parseISO } from "date-fns";
import { queryClient } from "../../../services/queryClient";
import { useDialogConfirmation } from "../../../hooks/useDialogConfirmation";
import { useToast } from "../../../hooks/useToast";

type ListTemplateProps = {
  onSelect: (data: any) => void;
};

export function ListTemplates({ onSelect }: ListTemplateProps) {
  const toast = useToast();
  const dialog = useDialogConfirmation();

  const { data: templatesList = [], isFetching: isLoadingTemplates } = useQuery(
    "listEmailTemplates",
    async () => {
      const response = await listEmailTemplates();
      return response;
    }
  );

  const newDeleteTemplate = useMutation(
    async (param1: any) => {
      toast.show("Deletando...", { severity: "info" });

      const response = await deleteTemplate(param1);
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Sucesso ao deletar template!", { severity: "success" });
      },
      onError: () => {
        toast.show("Erro ao deletar template!", {
          severity: "error",
        });
      },
    }
  );

  const handleDeleteTemplate = (id_template) => {
    dialog.show("Aviso", "Deseja realmente deletar esse template?", {
      onConfirmate: async () => {
        try {
          const response = await newDeleteTemplate.mutateAsync(id_template);

          if (response) {
          }
        } catch (err) {
          console.log({ err });
        }

        queryClient.invalidateQueries("templates component");

        dialog.close();
      },
    });
  };

  return (
    <Table
      data-testid="template-table-list-templates"
      isLoading={isLoadingTemplates}
      onRowClick={(columns, data) => {
        onSelect((prev) => ({
          ...prev,
          formatedData: {
            ...prev.formatedData,
            idTemplate: data.id_template,
            templateName: data.nome_template,
            templateSelecionado: data,
            templateType: {
              label: data.tipo_template,
              value: "html",
            },
          },
          trueData: data,
        }));
      }}
      search
      columnsButton
      pageSize={15}
      actions={[
        {
          icon: "arrow_downward",
          tooltip: "Download",
          onClick: (event, rowData) => {
            window.open(rowData.link_template, "_blank");
          },
        },
        {
          icon: () => <Icon color="action">edit</Icon>,
          tooltip: "Editar",
          onClick: (event, rowData) => {
            onSelect((prev) => ({
              ...prev,
              formatedData: {
                ...prev.formatedData,
                idTemplate: rowData.id_template,
                templateName: rowData.nome_template,
                templateSelecionado: rowData,
                templateType: {
                  label: rowData.tipo_template,
                  value: "html",
                },
              },
              trueData: rowData,
            }));
          },
        },
        {
          icon: () => <Icon color="error">delete</Icon>,
          tooltip: "Excluir",
          onClick: (event, rowData) =>
            handleDeleteTemplate(rowData.id_template),
        },
      ]}
      columns={[
        { title: "ID", field: "id_template" },
        { title: "Nome", field: "nome_template" },
        {
          title: "Data",
          field: "data_insert",
          render: (rowData) =>
            format(
              parseISO(rowData.data_insert?.replace("Z", "")),
              "dd/MM/yyyy HH:mm"
            ),
        },
        { title: "Tipo", field: "tipo_template" },
      ]}
      data={templatesList.data}
    />
  );
}
